import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = { class: "row mb-3" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "title-h4" }
const _hoisted_6 = { class: "row mb-3" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = {
  key: 0,
  class: "tab-pane fade in active show",
  id: "session_bookings",
  style: {"overflow-x":"auto"}
}
const _hoisted_9 = { class: "table table-striped table-bordered" }
const _hoisted_10 = { class: "thead-dark" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_btn_delete = _resolveComponent("btn-delete")!
  const _component_not_found = _resolveComponent("not-found")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isRequestBooking)
      ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.title")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.sessionBookingsList?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", _hoisted_10, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t('tables.sessionBooking.trainer')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.session_date")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.start_time")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.end_time")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.booking_status")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.attendance_status")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.i18n.t("tables.action")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sessionBookingsList, (booking) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: `booking-${booking?.id}`
                    }, [
                      _createElementVNode("td", null, _toDisplayString(booking.trainer?.name ?? "-"), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(booking.session_date)), 1),
                      _createElementVNode("td", null, _toDisplayString(booking.start_time), 1),
                      _createElementVNode("td", null, _toDisplayString(booking.end_time), 1),
                      _createElementVNode("td", null, _toDisplayString(booking.booking_status), 1),
                      _createElementVNode("td", null, [
                        (booking.attendance_status === 'pending')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-success me-1",
                                onClick: ($event: any) => (_ctx.markAttendance(booking.id, 'completed'))
                              }, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.present")), 9, _hoisted_12),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-danger",
                                onClick: ($event: any) => (_ctx.markAttendance(booking.id, 'absent'))
                              }, _toDisplayString(_ctx.i18n.t("views.clients.sessionBooking.absent")), 9, _hoisted_13)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(booking.attendance_status), 1))
                      ]),
                      _createElementVNode("td", null, [
                        (_ctx.hasPermission('delete_member_session_booking'))
                          ? (_openBlock(), _createBlock(_component_btn_delete, {
                              key: 0,
                              onDelete: ($event: any) => (_ctx.deleteSessionItem(booking?.id))
                            }, null, 8, ["onDelete"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_not_found, {
                text: _ctx.i18n.t('message.data_not_found.title'),
                icon: "warning"
              }, null, 8, ["text"])
            ]))
      ])
    ])
  ]))
}